import { useCallback } from 'react';

export type OnRegionalFilterChange<T extends string, U> = (filter: T, value: U) => void;

type OnSelectValueChange<U> = (value: U) => void;

export function useRegionalFilterChange<T extends string, U>(
  filter: T,
  onValueChange?: OnRegionalFilterChange<T, U>
): OnSelectValueChange<U> {
  const handleFilterChange = useCallback(
    (value: U) => {
      onValueChange?.(filter, value);
    },
    [filter, onValueChange]
  );

  return handleFilterChange;
}
